import React from 'react';

// data.jsx — 화면이 읽는 서버 데이터 저장소. 시작할 때는 비어 있고, load.js가 서버 응답으로 채운다(applyServerData).
// 화면은 적재가 끝난 뒤에만 그린다(shell.jsx loadState). 여기에 시안 값·가짜 사람을 두지 않는다(계획 문서 1.3, 시안 잔재 검사).

let ME = { id: '', name: '', email: '', dept: '', title: '', initials: '', roles: [] };
let DEPTS = [];
let PEOPLE = [];

/** 결재 요약(서버 집계) — 사이드바 배지·홈 '결재 대기' */
let APPROVAL_SUMMARY = { waiting: 0, in_progress: 0, rejected: 0, completed_this_month: 0 };
let ROOMS = [];
let BOOKINGS = [];
let LEAVE = { balance: { name: '', granted: 0, used: 0, pending: 0 }, types: [] };
let POSTS = [];
let TASKS = [];
/** 내 업무 요약(서버 집계 — 이번 주는 월~일) */
let TASK_SUMMARY = { doing: 0, todo: 0, hold: 0, due_today: 0, overdue: 0, week_done: 0, week_total: 0 };
let NOTIFS = [];
/** 내 화면 설정(서버 저장 — 적재 전 기본값) */
let PREFERENCES = { theme: 'dark', sidebar: 'expanded' };

// ---- 앱 카탈로그 -------------------------------------------------------
// 그룹웨어 외의 앱은 관리 화면에 등록된 운영 중 서비스 — 서버가 열 수 있는가(open|locked)·상태·즐겨찾기를 함께 준다(/api/v1/services, 계획 문서 5.3 3c).
// 잠김은 서버가 정한다(화면은 access를 그린다)
export const mapApp = (x) => ({ id: x.slug, name: x.name, desc: x.description || '', icon: x.icon || 'box', url: x.url, enabled: x.access === 'open',
  locked: x.access === 'locked', owner: x.owner_name ?? null, health: x.health ?? null, favorite: x.favorite === true, service: true });
const GROUPWARE_APP = { id: 'groupware', name: '그룹웨어', desc: '결재·게시판·조직도·예약·휴가', icon: 'grid', enabled: true };
let APPS = [GROUPWARE_APP];
/** 업무 정책 중 화면 계산에 쓰는 값(서버 /api/v1/policy — 계획 문서 5.4 4c). 기본값은 서버 기본과 같고 받으면 갈아끼운다 */
const POLICY = { leave: { workDay: { start: '09:00', halfSplit: '14:00', end: '18:00' }, daysOff: [6, 7], allowPastDates: false } };
let FIRST_VIEW = 'home';
let FEATURES = {};   // 사람마다 보이는 메뉴(/me features — 메일 에이전트 등)   // 첫 화면 — 서버가 진입 호스트별로 정한다(/me firstView)
/** 서비스 목록을 받지 못했으면 그 오류(런처가 보인다) */
let APPS_ERROR = null;

/**
 * 서버 데이터로 교체한다. 시안 컴포넌트가 이 모듈 값을 직접 참조하므로
 * 값을 갈아끼우고 App이 재렌더링한다 (ESM live binding).
 */
function applyServerData(d) {
  if (d.me) ME = d.me;
  if (d.policy) Object.assign(POLICY, d.policy);
  if (d.firstView) FIRST_VIEW = d.firstView;
  if (d.features) FEATURES = d.features;
  if (d.depts) DEPTS = d.depts;
  if (d.people) PEOPLE = d.people;
  if (d.approvalSummary) APPROVAL_SUMMARY = d.approvalSummary;
  if (d.rooms) ROOMS = d.rooms;
  if (d.bookings) BOOKINGS = d.bookings;
  if (d.leave) LEAVE = d.leave;
  if (d.posts) POSTS = d.posts;
  if (d.tasks) TASKS = d.tasks;
  if (d.taskSummary) TASK_SUMMARY = d.taskSummary;
  if (d.notifs) NOTIFS = d.notifs;
  if (d.preferences) PREFERENCES = d.preferences;
  if (d.services) APPS = [GROUPWARE_APP, ...d.services.map(mapApp)];
  if (d.servicesError !== undefined) APPS_ERROR = d.servicesError;
}

export { applyServerData, FEATURES, FIRST_VIEW, POLICY, PREFERENCES, APPROVAL_SUMMARY, APPS, APPS_ERROR, BOOKINGS, DEPTS, LEAVE, ME, NOTIFS, PEOPLE, POSTS, ROOMS, TASK_SUMMARY, TASKS };
